import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Login from '@/components/Login'
import Welcome from '@/components/Welcome'
import Password from '@/components/User/Password'
import CustomerList from '@/components/Customer/Index'
import EditCustomer from '@/components/Customer/Edit'
import SubRole from '@/components/Customer/SubRole'
import MoneyRole from '@/components/Customer/MoneyRole'
import ProductList from '@/components/Product/productList'
import EditProduct from '@/components/Product/EditProduct'
import ProductAge from '@/components/ProductParams/Age'
import ProductClass from '@/components/ProductParams/Class'
import ProductPcs from '@/components/ProductParams/Pcs'
import ProductTenancy from '@/components/ProductParams/Tenancy'
import GatewayList from '@/components/Devices/GatewayList'
import DeliverLog from '@/components/Devices/DeliverLog'
import DeliverList from '@/components/Devices/DeliverList'
import DeliverNoLog from '@/components/Devices/DeliverNoLog'
import UserList from '@/components/User/Index'
import CreateUser from '@/components/User/Add'
import EditUser from '@/components/User/Edit'
import VersionUpload from '@/components/Devices/VersionUpload'
import NotFound from '@/components/404'
import FactoryList from '@/components/Factory/Index'
import CreateFactory from '@/components/Factory/Add'
import EditFactory from '@/components/Factory/Edit'
import ProducerList from '@/components/Producer/Index'
import CreateProducer from '@/components/Producer/Add'
import EditProducer from '@/components/Producer/Edit'

import Devices from '@/components/Devices/Index'
import HeatpumpC from '@/components/Devices/HeatpumpControl'
import Heatpump from '@/components/Devices/Heatpump'
import Aircondition from '@/components/Devices/Aircondition'
import Acb from '@/components/Devices/Acb'
import Adv from '@/components/Devices/Adv'
import HistoryError from '@/components/Devices/HistoryError'
import OptLog from '@/components/Devices/OptLog'
import VersionLog from '@/components/Devices/VersionLog'
import RealtimeError from '@/components/Devices/RealtimeError'
import DeviceReport from '@/components/Devices/Report'
import CreateProtocol from '@/components/Protocol/Add'
import CreateSetProtocol from '@/components/Protocol/Set'
import Mibee from '@/components/Devices/Mibee'

import ProduceList from '@/components/Produce/Index'
import CreateProduce from '@/components/Produce/Add'
import EditProduce from '@/components/Produce/Edit'
import VersionList from '@/components/Version/Index'
import EditVersion from '@/components/Version/Edit'

Vue.use(Router)

export default new Router({
  routes: [

    {
      path: '/',
      name: '',
      component: Index,
      children: [
        {
          name: 'Welcome',
          path: '',
          component: Welcome
        },
        {
          name: 'Account',
          path: 'Account',
          component: UserList
        },
        {
          name: 'CreateUser',
          path: 'CreateUser',
          component: CreateUser
        },
        {
          name: 'EditUser',
          path: 'EditUser/:innerid',
          component: EditUser
        },

        {
          name: 'Password',
          path: 'Password',
          component: Password
        },
        {
          name: 'CustomerList',
          path: 'CustomerList',
          component: CustomerList
        },
        {
          name: 'EditCustomer',
          path: 'EditCustomer/:innerid',
          component: EditCustomer
        },
{
          name: 'SubRole',
          path: 'SubRole',
          component: SubRole
        },
        {
          name: 'MoneyRole',
          path: 'MoneyRole',
          component: MoneyRole
        },
        {
          name: 'ProductList',
          path: 'ProductList',
          component: ProductList
        },
         {
          name: 'EditProduct',
          path: 'EditProduct/:innerid',
          component: EditProduct
        },
        {
          name: 'ProductAge',
          path: 'ProductAge',
          component: ProductAge
        },
        {
          name: 'ProductClass',
          path: 'ProductClass',
          component: ProductClass
        },
        {
          name: 'ProductPcs',
          path: 'ProductPcs',
          component: ProductPcs
        },
        {
          name: 'ProductTenancy',
          path: 'ProductTenancy',
          component: ProductTenancy
        },
        {
          name: 'GatewayList',
          path: 'GatewayList',
          component: GatewayList
        },
        {
          name: 'DeliverList',
          path: 'DeliverList',
          component: DeliverList
        },
        {
          name: 'DeliverLog',
          path: 'DeliverLog/:deliverno',
          component: DeliverLog
        },
        {
          name: 'DeliverNoLog',
          path: 'DeliverNoLog',
          component: DeliverNoLog
        },
        {
          name: 'VersionUpload',
          path: 'VersionUpload',
          component: VersionUpload
        },
        {
          name: 'Factory',
          path: 'Factory',
          component: FactoryList
        },
        {
          name: 'CreateFactory',
          path: 'CreateFactory',
          component: CreateFactory
        },
        {
          name: 'EditFactory',
          path: 'EditFactory/:innerid',
          component: EditFactory
        },
        {
          name: 'Producer',
          path: 'Producer',
          component: ProducerList
        },
        {
          name: 'CreateProducer',
          path: 'CreateProducer',
          component: CreateProducer
        },
        {
          name: 'EditProducer',
          path: 'EditProducer/:innerid',
          component: EditProducer
        },
        {
          name: '',
          path: '',
          component: Devices,
          children: [{
            path: 'Devices/:equipmentid',
            name: 'Devices',
            components: {
              heatpumpC: HeatpumpC,
              heatpump: Heatpump,
              aircondition: Aircondition,
              acb: Acb,
              historyError: HistoryError,
              optLog: OptLog,
              real: RealtimeError,
              report: DeviceReport,
              mibee: Mibee,
              customerList: CustomerList,
              adv: Adv,
              versionLog: VersionLog
            }
          } ]
        },
        {
          name: 'CreateProtocol',
          path: 'CreateProtocol/:type/:related/:innerid',
          component: CreateProtocol
        },
        {
          name: 'CreateSetProtocol',
          path: 'CreateSetProtocol/:type/:related/:innerid',
          component: CreateSetProtocol
        },
        {
          name: 'Produce',
          path: 'Produce',
          component: ProduceList
        },
        {
          name: 'CreateProduce',
          path: 'CreateProduce',
          component: CreateProduce
        },
        {
          name: 'EditProduce',
          path: 'EditProduce/:innerid',
          component: EditProduce
        },
        {
          name: 'Version',
          path: 'Version',
          component: VersionList
        },
        {
          name: 'EditVersion',
          path: 'EditVersion/:innerid',
          component: EditVersion
        },
        {
          name: 'NotFound',
          path: '*',
          component: NotFound
        }
      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
})
const originalPush = Router.prototype.push
Router.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js